export const markAsRead = "PsqBhe";
export default {markAsRead};